module.exports = __webpack_public_path__ + "img/Hero.f7f817d2.svg";